module.exports = __webpack_public_path__ + "img/ideal.c7200910.svg";